<template>
    <div>

        <!-- Highlight Customer Start -->
        <div class="highlightFilterRow" v-if="is_customer_page">
            <div class="row">
                <!-- Date Buttons Filter Start -->
                <div class="col-md-5">
                    <div class="row">
                        <div class="col-md" v-for="(button, index) in options.dateButtons">
                            <button
                                class="btn btn--ahmoil-v3"
                                :class="{'selected' : selected.dateButtonsIndex == index}"
                                @click="selectDateButton(index)"
                            >{{ button.title }}</button>
                        </div>
                    </div>
                </div>
                <!-- Date Buttons Filter End -->
                
                <!-- Flat Pickr Start -->
                <div class="col-md-3">
                    <flat-pickr
                        :config="rangePickr"
                        placeholder="Select Date"
                        v-model="selected.date"
                    ></flat-pickr>
                </div>
                <!-- Flat Pickr End -->

                <!-- MultiSelect Start -->
                <div class="col-md-2">
                    <MultiSelect 
                        v-model="filter.variant"
                        :options="options.variant"
                        :deselect-label="''"
                        placeholder="All Variants"
                        class="elegant-multiselect"
                    />
                </div>
                <div class="col-md-2">
                    <MultiSelect 
                        v-model="filter.oilmaker"
                        :options="options.oilMaker.map(x => x.code)"
                        :custom-label="opt => options.oilMaker.find(x => x.code == opt).title"
                        :deselect-label="''"
                        placeholder="All Oil Makers"
                        class="elegant-multiselect"
                    />
                </div>
                <!-- MultiSelect End -->
            </div>
        </div>
        <!-- Highlight Customer End -->





        <!-- Highlight Label Maker & Oil Maker Start -->
        <div class="highlightFilterRow" v-else>
            <div class="row">
                <!-- Date Buttons Filter Start -->
                <div class="col-md-6 offset-md-3">
                    <div class="row">
                        <div class="col-md" v-for="(button, index) in options.dateButtons">
                            <button
                                class="btn btn--ahmoil-v3"
                                :class="{'selected' : selected.dateButtonsIndex == index}"
                                @click="selectDateButton(index)"
                            >{{ button.title }}</button>
                        </div>
                    </div>
                </div>
                <!-- Date Buttons Filter End -->
                
                <!-- Flat Pickr Start -->
                <div class="col-md-3">
                    <flat-pickr
                        :config="rangePickr"
                        placeholder="Select Date"
                        v-model="selected.date"
                    ></flat-pickr>
                </div>
                <!-- Flat Pickr End -->
            </div>
            <div class="row">
                <!-- MultiSelect Start -->
                <div class="col-md-3">
                    <MultiSelect 
                        v-model="filter.variant"
                        :options="options.variant"
                        :deselect-label="''"
                        placeholder="All Variants"
                        class="elegant-multiselect"
                    />
                </div>
                <div class="col-md-3">
                    <MultiSelect 
                        v-model="filter.labelmaker"
                        :options="options.labelMaker"
                        :deselect-label="''"
                        placeholder="All Label Makers"
                        class="elegant-multiselect"
                    />
                </div>
                <div class="col-md-3">
                    <MultiSelect 
                        v-model="filter.bottlemaker"
                        :options="options.bottleMaker"
                        :deselect-label="''"
                        placeholder="All Bottle Makers"
                        class="elegant-multiselect"
                    />
                </div>
                <div class="col-md-3">
                    <MultiSelect 
                        v-model="filter.oilmaker"
                        :options="options.oilMaker.map(x => x.code)"
                        :custom-label="opt => options.oilMaker.find(x => x.code == opt).title"
                        :deselect-label="''"
                        placeholder="All Oil Makers"
                        class="elegant-multiselect"
                    />
                </div>
                <!-- MultiSelect End -->
            </div>
        </div>
        <!-- Highlight Label Maker & Oil Maker End -->

    </div>
</template>

<script>
    import moment from 'moment';
    import debounce from 'debounce';

    export default {
        data () {
            let startDate = moment().startOf('month').format("YYYY-MM-DD");
            let currentDate = moment().format("YYYY-MM-DD");

            return {
                rangePickr: {
                    mode: 'range',
                    dateFormat: "Y-m-d",
                    altInput: true,
                    altFormat: "d-m-Y",
                    altInputClass: 'form-control input elegant-flatpickr'
                },
                
                options : {
                    dateButtons : [
                        // {title:'Today', start:`${moment().format('YYYY-MM-DD')}`, end:`${moment().format('YYYY-MM-DD')}`, filter:'DAILY'},
                        {title:'This Week', start:`${moment().subtract(6, 'days').format('YYYY-MM-DD')}`, end:`${moment().format('YYYY-MM-DD')}`, filter:'WEEKLY'},
                        {title:'This Month', start:`${moment().startOf('month').format('YYYY-MM-DD')}`, end:`${moment().format('YYYY-MM-DD')}`, filter:'MONTHLY'},
                        {title:'This Year', start:`${moment().startOf('year').format('YYYY-MM-DD')}`, end:`${moment().format('YYYY-MM-DD')}`, filter:'YEARLY'},
                    ],

                    variant : this.$store.getters.getVariant,
                    labelMaker : this.$store.getters.getLabelMaker,
                    oilMaker : this.$store.getters.getOilMaker,
                    bottleMaker : this.$store.getters.getBottleMaker,
                },
                selected : {
                    dateButtonsIndex : 1,
                    date : `${startDate} to ${currentDate}`
                },
                filter : {
                    start : startDate,
                    end : currentDate,
                    variant : null,
                    labelmaker : null,
                    bottlemaker : null,
                    oilmaker : null,
                    filter : 'MONTHLY',
                }
            }
        },
        props : [
            'getFilterOnStart',
            'is_customer_page'
        ],
        mounted () {
            if (this.getFilterOnStart) this.debouncelessEmitFilter();
        },
        watch : {
            'selected.date' () {
                let split = this.selected.date.split(" to ");
                this.filter.start = split[0];
                this.filter.end = split.length > 1 ? split[1] : split[0];

                // console.log('%chighlightFilter.vue line:193 this.selected.dateButtonsIndex ', 'color: #007acc;', this.selected.dateButtonsIndex );

                //Check End
                if (this.filter.end != moment().format('YYYY-MM-DD')){
                    this.selected.dateButtonsIndex = -1;
                //Check Start
                } else if (this.options.dateButtons.map(x=>x.start).indexOf(this.filter.start) == -1) {
                    this.selected.dateButtonsIndex = -1;
                //Found Match
                } else {
                    this.selected.dateButtonsIndex = this.options.dateButtons.map(x=>x.start).indexOf(this.filter.start);
                }
            },
            'selected.dateButtonsIndex' () {
                this.filter.filter = this.selected.dateButtonsIndex != -1 ? this.options.dateButtons[this.selected.dateButtonsIndex].filter : 'CUSTOM'
            },
            'filter' : {
                deep : true,
                handler : 'emitFilter'
            },
        },
        methods : {
            selectDateButton (i) {
                this.selected.date = `${this.options.dateButtons[i].start} to ${this.options.dateButtons[i].end}`
                this.selected.dateButtonsIndex = i;
            },
            debouncelessEmitFilter () {
                let filter = JSON.parse(JSON.stringify(this.filter));
                for (var i in filter) if (filter[i] == null || filter[i] === '') delete filter[i];
                this.$emit('filterChange', filter);
            },
            emitFilter: debounce(function (e) {
                let filter = JSON.parse(JSON.stringify(this.filter));
                for (var i in filter) if (filter[i] == null || filter[i] === '') delete filter[i];
                this.$emit('filterChange', filter);
            }, 1500)
        }
    }
</script>

<style scoped>
    .highlightFilterRow > .row:not(:first-child) > div {
        margin-top: 20px;
    }

    .btn--ahmoil-v3 {
        background-color: white;
        box-shadow: 0 0 6px #0000000F;
        color: #B5B5B5;
        width: 100%;
        text-align: left;
        height: 36px;
    }

    .btn--ahmoil-v3.selected {
        background-color: #D5E8FF;
        color: #134F97;
    }
</style>